 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML04_COPYRIGHT from '@/components/html/04_Copyright'
 import HTML03_TITLE_PAGE from '@/components/html/03_Title_Page'
 import HTML02_SERIES_PAGE from '@/components/html/02_Series_Page'
 import HTML05_DEDICATION from '@/components/html/05_Dedication'
 import HTML06_CONTENTS from '@/components/html/06_CONTENTS'
 import HTML07_PREFACE from '@/components/html/07_Preface'
 import HTML08_1__THE_IRONIES_OF_AFFIRMATIVE_AC from '@/components/html/08_1__The_Ironies_of_Affirmative_Ac'
 import HTML09_PART_I__UNDERSTANDING_RESISTANCE from '@/components/html/09_Part_I__Understanding_Resistance'
 import HTML10_2__THE_APPEAL_OF_COLOR_BLINDNESS from '@/components/html/10_2__The_Appeal_of_Color_Blindness'
 import HTML11_3__AMERICAN_JUSTICE__ACCEPTABLE from '@/components/html/11_3__American_Justice__Acceptable'
 import HTML12_PART_II__UNDERSTANDING_SUPPORT_F from '@/components/html/12_Part_II__Understanding_Support_f'
 import HTML13_4__CRISIS_MANAGEMENT_THROUGH_AFF from '@/components/html/13_4__Crisis_Management_through_Aff'
 import HTML14_5__ADMINISTRATIVE_PRAGMATISM_AND from '@/components/html/14_5__Administrative_Pragmatism_and'
 import HTML15_6__AFFIRMATIVE_ACTION_AS_TRADITI from '@/components/html/15_6__Affirmative_Action_as_Traditi'
 import HTML16_7__CREATIVE_DESTRUCTION_IN_THE_N from '@/components/html/16_7__Creative_Destruction_in_the_N'
 import HTML17_8__CONCLUSION__CULTURE__POLITICS from '@/components/html/17_8__Conclusion__Culture__Politics'
 import HTML18_NOTES from '@/components/html/18_Notes'
 import HTML19_INDEX from '@/components/html/19_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/06_CONTENTS",
 			"name" : "html/06_CONTENTS",
 			"component" : HTML06_CONTENTS
 		},
 		{
 			"path" : "/html/07_Preface",
 			"name" : "html/07_Preface",
 			"component" : HTML07_PREFACE
 		},
 		{
 			"path" : "/html/08_1__The_Ironies_of_Affirmative_Ac",
 			"name" : "html/08_1__The_Ironies_of_Affirmative_Ac",
 			"component" : HTML08_1__THE_IRONIES_OF_AFFIRMATIVE_AC
 		},
 		{
 			"path" : "/html/09_Part_I__Understanding_Resistance",
 			"name" : "html/09_Part_I__Understanding_Resistance",
 			"component" : HTML09_PART_I__UNDERSTANDING_RESISTANCE
 		},
 		{
 			"path" : "/html/10_2__The_Appeal_of_Color_Blindness",
 			"name" : "html/10_2__The_Appeal_of_Color_Blindness",
 			"component" : HTML10_2__THE_APPEAL_OF_COLOR_BLINDNESS
 		},
 		{
 			"path" : "/html/11_3__American_Justice__Acceptable",
 			"name" : "html/11_3__American_Justice__Acceptable",
 			"component" : HTML11_3__AMERICAN_JUSTICE__ACCEPTABLE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js